import { render, staticRenderFns } from "./IconRewardRestaurant.vue?vue&type=template&id=598f7a81"
import script from "./IconRewardRestaurant.vue?vue&type=script&lang=js"
export * from "./IconRewardRestaurant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports